import React, { Component } from 'react';
import { Label, Loader } from 'semantic-ui-react';

export default class extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <Label>{this.props.count ?
                this.props.count :
                <Loader active inline size='mini' />
            }
            </Label>
        );
    }
}
